import React, { useRef, useState, useEffect } from "react";
import { DropdownStyled, DropdownToggleStyled, DropdownMenuStyled, DropdownMenuItemStyled } from "./Dropdown.styles";
import arrowDownIcon from '../icons/ArrowDown.icon.svg';

const Dropdown = ({ options = [], defaultOption = {}, onChange = (f) => f }) => {
	const dropdownRef = useRef(null);

	const [isOpen, setIsOpen] = useState(false);

	const handleItemClick = (option) => {
		onChange(option.value)
		setIsOpen(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<DropdownStyled ref={dropdownRef}>
			<DropdownToggleStyled onClick={() => setIsOpen(!isOpen)}>
				<div>{defaultOption.label}</div>
				<img src={arrowDownIcon} alt="arrow-icon"/>
			</DropdownToggleStyled>

			{isOpen && (
				<DropdownMenuStyled>
					{options?.map((option, index) => (
						<DropdownMenuItemStyled key={index} onClick={() => handleItemClick(option)} active={defaultOption.value === option.value}>
							{option.label}
						</DropdownMenuItemStyled>
					))}
				</DropdownMenuStyled>
			)}
		</DropdownStyled>
	);
};

export default Dropdown;
